module.exports = __webpack_public_path__ + "static/img/walking-man-yellow.0a61242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-yellow.svg
// module id = 3YJz
// module chunks = 82